<div class="upload-container" (click)="fileInput.click()" *ngIf="!photoLoading" title="{{'Add photo' | translate | async}}">
  <i class="material-icons upload-container__icon">
    add_a_photo
  </i>
  <input style="display: none;" type="file"
         #fileInput accept="image/*"
         (change)="onSelectPhoto($event)" hidden>
</div>
<mat-spinner diameter="24" *ngIf="photoLoading"></mat-spinner>

